export const loadScript = (url, dataConfig) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  if (script.readyState) { // IE
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
      }
    }
  }

  script.src = url
  script.setAttribute('data-config', dataConfig)
  document.getElementsByTagName('head')[0].appendChild(script)
}
